import Type from './Type';
export function isIGradedText(node) {
    return node.type === Type.GradedText;
}
export default isIGradedText;    //# sourceMappingURL=isIGradedText.js.map
